import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import Switch from 'app/pages/design/landingPageBuilder/components/Switch';

const PodiumSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
  color: ${({ theme }) => theme.colors.secondary[100]};
  font-size: 16px;
`;

interface PodiumSwitchProps {
  isPodiumConnected: number;
  sendSmsFlag: boolean;
  usePodium: boolean;
  setUsePodium: (value: boolean) => void;
  isSmsSwitchDisabled: boolean;
}

export const PodiumSwitch: React.FC<PodiumSwitchProps> = ({
  isPodiumConnected,
  sendSmsFlag,
  usePodium,
  setUsePodium,
  isSmsSwitchDisabled,
}) => {
  const themes = useTheme();

  if (!isPodiumConnected || !sendSmsFlag) {
    return null;
  }

  return (
    <PodiumSwitchWrapper>
      <Switch
        id={'switch-podium'}
        isOn={usePodium}
        onColor={themes.colors.primary[100]}
        handleToggle={() => {
          setUsePodium(!usePodium);
        }}
        disabled={isSmsSwitchDisabled}
      />
      Send with Podium
    </PodiumSwitchWrapper>
  );
};
